import axios from 'axios'
import { getCookie, setCookie, removeCookie } from 'tiny-cookie'

const BACKEND_URL = process.env.VUE_APP_BACKEND_URL
const NOM_TOKEN = 'tokenTTBox'

// Ajout du token pour appeler l'API
// Le token est stocké dans le cookie
axios.interceptors.request.use(
    (config) => {
        if (config.url.includes(BACKEND_URL)) {
            var token = getCookie(NOM_TOKEN)
            if (token){
                config.headers['Authorization'] = 'Bearer ' + token
            }
        }
        return config
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default {
    connecter(username, password){
        var payload = {
            "username": username,
            "password": password
        }
        return new Promise(function (resolve, reject) {
            axios.post(`${BACKEND_URL}/users/login`, payload)
            .then((response) => {
                setCookie(NOM_TOKEN, response.data.token, { expires: '1M' });
                resolve();
            })
            .catch(() => reject())
        })
    },
    deconnecter() {
        removeCookie(NOM_TOKEN);
    },
    lireUnites() {
        return axios.get(`${BACKEND_URL}/unites`)
        .then((response) => response.data.unites)
    },
    lireInterfaces() {
        return axios.get(`${BACKEND_URL}/interfaces`)
        .then((response) => response.data.interfaces)
    },
    lireValeursOptionInterface(idOptionInterface, periode, annee, mois, jour) {
        let parametres = "periode=" + periode
        if (annee != undefined) {
            parametres += "&annee=" + annee
        }
        if (mois != undefined) {
            parametres += "&mois=" + mois
        }
        if (jour != undefined) {
            parametres += "&jour=" + jour
        }
        return axios.get(`${BACKEND_URL}/optioninterface/${idOptionInterface}/valeurs?${parametres}`)
        .then((response) => response.data.valeurs)
    },
    executerOption(optionInterface) {
        let parametre = ''
        if (optionInterface.valeur) {
            parametre = '?valeur=' + optionInterface.valeur
        }
        return axios.get(`${BACKEND_URL}/optionInterface/` + optionInterface.idOptionInterface + parametre)
    },
    lireRegles(){
        return axios.get(`${BACKEND_URL}/regles`)
        .then((response) => response.data.regles)
    },
    creerRegle(regle){
        return axios.post(`${BACKEND_URL}/regles`, regle)
    },
    modifierRegle(regle){
        return axios.put(`${BACKEND_URL}/regles`, regle)
    },
    supprimerRegle(regle){
        return axios.delete(`${BACKEND_URL}/regles/` + regle.idRegle)
    }
}